"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var activityColumns = [
    { name: "Date", uid: "created_at" },
    { name: "Player", uid: "user_name" },
    { name: "Item", uid: "item_name" },
    { name: "Type", uid: "item_type" },
    { name: "Kind", uid: "kind" },
    { name: "Quantity", uid: "quantity" },
    { name: "Uses", uid: "uses" },
    { name: "Source", uid: "source_type" },
    { name: "By", uid: "actor" },
    { name: "Reason", uid: "reason" },
];
function useColumns(hiddenColumns) {
    var columns = (0, react_1.useMemo)(function () { return activityColumns.filter(function (column) { return !hiddenColumns.includes(column.uid); }).map(function (column) { return (__assign(__assign({}, column), { id: column.uid })); }); }, [hiddenColumns]);
    return (0, react_1.useMemo)(function () { return ({ columns: columns, headerColumns: columns }); }, [columns]);
}
